import { User } from "@/common/types/user";
import OrgAccountDetailsOnboardingStep from "../components/OrgAccountDetailsOnboardingStep";
import { OrgOnboardingStep } from "../enums/OrgOnboardingStep";

export type OrgOnboardingStepConfig = {
  title: string;
  id: OrgOnboardingStep;
  component: React.ComponentType<{
    onComplete: () => void;
    onBack?: () => void;
  }>;
  icon: React.ComponentType<{ className: string }>;
  valid: (user: User) => boolean;
  hideStepper: boolean;
};

const ORG_ONBOARDING_STEPS: OrgOnboardingStepConfig[] = [
  {
    title: "Account Details",
    id: OrgOnboardingStep.ACCOUNT_DETAILS,
    component: OrgAccountDetailsOnboardingStep,
    hideStepper: false,
    icon: ({ className }: { className: string }) => (
      <svg
        className={className}
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 20 16"
      >
        <path d="M18 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2ZM6.5 3a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3.014 13.021l.157-.625A3.427 3.427 0 0 1 6.5 9.571a3.426 3.426 0 0 1 3.322 2.805l.159.622-6.967.023ZM16 12h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2Zm0-3h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2Zm0-3h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2Z"></path>
      </svg>
    ),
    valid: (user: User) => {
      return Boolean(user.first_name?.trim() && user.last_name?.trim());
    },
  },
];

/**
 * Returns all org onboarding steps.
 * Use this for navigation to allow users to go back to completed steps.
 */
export function getAllOrgOnboardingSteps(): OrgOnboardingStepConfig[] {
  return ORG_ONBOARDING_STEPS;
}

/**
 * Returns only incomplete org onboarding steps.
 * Use this to determine the first incomplete step or check if onboarding is complete.
 */
export function getOrgOnboardingSteps(user: User): OrgOnboardingStepConfig[] {
  return getAllOrgOnboardingSteps().filter((step) => !step.valid(user));
}
